"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/NAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_166)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_166`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.28003 0.000244141H33.72V23.9998H-2.28003V0.000244141Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.28003 23.9998V0.000244141H33.72",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M33.72 4.7031V0.000244141H26.6655L-2.28003 19.2969V23.9998H4.77443L33.72 4.7031Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M33.72 0.000244141V2.82154L1.9523 23.9998H-2.28003V21.1785L29.4877 0.000244141H33.72Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.9202 7.30396L9.32121 8.05602L10.1727 9.60459L8.43646 9.27243L8.21646 11.0264L7.00715 9.73635L5.79778 11.0264L5.57777 9.27243L3.84154 9.60452L4.69295 8.05602L3.09412 7.30396L4.69302 6.55183L3.84154 5.0034L5.57777 5.33542L5.79785 3.58154L7.00715 4.87157L8.21653 3.58154L8.43646 5.33542L10.1727 5.0034L9.32135 6.55197L10.9202 7.30396Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_166`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as NAFlag };
